import React from 'react'

export default ({ level, unit }) => (
    <text x={unit} y={unit * 3.5} fontSize={unit} className='level'>LEVEL: {level}</text>
)